module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_6005.b7a4b31d.png";